import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { Checkbox } from 'primereact/checkbox'
import { InputNumber } from 'primereact/inputnumber'
import { Dialog } from 'primereact/dialog'
import { acoes, enums, icons, routes } from '../../../constants'
import { Page } from '../../../components/page/Page'
import { LancamentoVendasList } from './LancamentoVendasList'
import { actions } from '../lancamento-vendas.actions'
import { LoadingSpinner } from '../../../components/loadingSpinner/LoadingSpinner'
import { DefaultToolBar } from '../../../components/toolbar/DefaultToolBar'
import * as listPageUtils from '../../../utils/listPageContainerUtils'
import utils, { isTipoFiltroSelecionado, isTipoFiltroSelecionadoComplementar } from '../../../utils/index'
import storage from '../../../services/stoage.service'
import { ConfirmDialog } from '../../../components/confirmDialog/ConfirmDialog'
import '../../../index.scss'
import { RadioButton } from 'primereact/radiobutton'
import LtsLookupMarcador from '../../../components/lottus/lts-lookup-marcador'
import _ from 'lodash'
import LtsLookupContaCorrente from '../../../components/lottus/lts-lookup-conta-corrente'
import { logarAcesso } from '../../../services/api-log-acesso'
import {
  luGetCustomButtons,
  luGetDialogConfirmarFecharPedidos,
  luGetDialogConfirmarReajustarLancamento,
  luOnConfirmBaixarLancamentos,
  mapDispatchToPropsLancamentoVendas,
  mapStateToPropsLancamentoVendas,
} from '../../../utils/lancamento-list-utils'
import LtsLookupItemLancamento from '../../../components/lottus/lts-lookup-item-lancamento'
import LtsLookupNotaFiscalServico from '../../../components/lottus/lts-lookup-nota-fiscal-servico'
import BaixarLancamentoModal from '../../lancamentoFinanceiro/baixar-lancamento-modal'

const mapStateToProps = (state) => {
  return mapStateToPropsLancamentoVendas(state)
}
const mapDispatchToProps = (dispatch) => {
  return mapDispatchToPropsLancamentoVendas(dispatch)
}

class LancamentoVendasListPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.dataTableRef = React.createRef()
    this.messagesFilters = storage.getAppLabels('filtros')
    this.showHideColumns = []
    this.orderedColumns = []
    this.state = {
      showDialogVisao: false,
      showDialogRemoveVisao: false,
      showConfirmarCancelar: false,
      showProcessarArquivoRetorno: false,
      showConfirmarGerarNFSeLote: false,
      showConfirmarFecharPedido: false,
      showConfirmarReajusteLancamento: false,
      contaBancaria: props.contasBancarias.length === 1 ? props.contasBancarias[0] : null,
      contaCorrente: null,
      tipoImportacao: 'BOLETO',
      dataInicial: null,
      dataFinal: null,
      dadosFavorito: null,
      favorito: 0,
      filtroAvancado: {},
      permissoes: listPageUtils.getPermissoesPorMenu(this),
      FECHAR_PEDIDO_STONE: storage.getAcao(acoes.FECHAR_PEDIDO_STONE),
      ACAO_CANCELAR_LANCAMENTOS: storage.getAcao(acoes.ACAO_CANCELAR_LANCAMENTOS),
      ACAO_REAJUSTAR_LANCAMENTOS: storage.getAcao(acoes.ACAO_REAJUSTAR_LANCAMENTOS),
    }

    this.onColumnToggle = this.onColumnToggle.bind(this)
  }

  static getDerivedStateFromProps(props, prevState) {
    if (props.contasCorrentes?.length === 1) {
      prevState.contaCorrente = props.contasCorrentes[0]
    }

    return { ...prevState, ...props }
  }

  //parametro com todas as colunas selecionadas atualmente
  onColumnToggle(event) {
    listPageUtils.onColumnToggle(event, this)
  }

  // MÉTODO CHAMADO AO REORDENAR AS COLUNAS
  onColReorder(e, colunasAtuais) {
    listPageUtils.onColumnReorder(e, colunasAtuais, this)
  }

  loadFavorito() {
    listPageUtils.loadFavorito(this, actions)
  }

  changeFavorito() {
    listPageUtils.changeFavorito(this, actions)
  }

  changeDataFiltro = (campo, valor) => {
    _.set(this.props.filterValues, campo, valor)
  }

  onChangeUnit = (e) => {
    _.set(this.props.filterValues, 'unidade.valor', e.target.value)
  }

  lookupNotaFiscalServicoOnChange = (e) => {
    _.set(this.props.filterValues, 'nfse.valor', e)
    this.props.lookupNotaFiscalServicoSetVisible(false)
  }

  lookupTaxaOnChange = (e) => {
    _.set(this.props.filterValues, 'taxa.valor', e)
    this.props.lookupTaxaSetVisible(false)
  }

  taxaDropDownTemplate = (taxa) => {
    return taxa.grupoFinanceiro_descricao
  }

  pesquisaAvancada = () => {
    this.showFilter = false
    this.props.pesquisaAvancada(this.state, this.props)
  }

  showFormVisao = () => {
    this.setState({ showDialogVisao: true })
  }

  showDialogRemoveVisao = () => {
    this.setState({ showDialogRemoveVisao: true })
  }

  removerState = () => {
    this.props.removerState()
  }

  salvarState = (dados, state) => {
    const dynamicFilters = this.getDynamicFilters(state)
    let orderedColumns = this.orderedColumns
    let columns = this.props.columns
    let arrayColumns = columns.filter((c) => c.visible)

    arrayColumns.forEach((col) => {
      let coluna = orderedColumns.find((co) => co.columnKey === col.columnKey)
      if (!coluna) {
        orderedColumns.push(col)
      }
    })

    orderedColumns.forEach((col) => {
      col.relationships = col.relacionamento
      delete col.relacionamento
    })

    dados.columns = orderedColumns
    dados.menu = { id: 1, value: this.props.history.location.pathname }
    dados.filters.push(...dynamicFilters)

    dados.filters.forEach((f) => {
      f.chaveComponente = f.chaveComponente || f.campo

      if (this.props.filterValues[f.chaveComponente]) {
        f.valorComponente = JSON.stringify(this.props.filterValues[f.chaveComponente].valor)
        f.valorComponenteComplementar = JSON.stringify(this.props.filterValues[f.chaveComponente].valorComplementar)
      }
    })

    this.props.salvarState(dados, dados.filters)
  }

  newHandler = () => {
    this.props.history.push(`${routes.PATH_LANCAMENTO_FINANCEIRO_VENDAS}/novo`)
  }

  componentDidMount() {
    logarAcesso().then()
    _.set(this.props.filterValues, 'taxa.valor', null)
    this.props.loadContasCorrentes()
    this.props.clearSelectedFilters()
    this.props.carregarLancamentos()
    this.loadFavorito()

    const componenteFilterOptions = utils.getFilters(storage.getAppLabels('filtros'))

    setTimeout(() => {
      const filtroAvancado = {}
      for (const key of Object.keys(this.props.filterValues)) {
        filtroAvancado[key] = this.props.filterValues[key]

        if (key === 'taxa') {
          let tipoFiltro = this.props.filterValues[key].tipoFiltro
          if (tipoFiltro?.value === 11) {
            //IGUAL A ==>> ESTA_CONTIDO_EM (11)
            tipoFiltro = componenteFilterOptions.find((c) => c.value === 0)
          } else if (tipoFiltro?.value === 15) {
            //DIFERENTE_DE ==>> NAO_ESTA_CONTIDO_EM (15)
            tipoFiltro = componenteFilterOptions.find((c) => c.value === 1)
          }
          this.props.filterValues[key].tipoFiltro = tipoFiltro
        }
      }
      this.setState({ filtroAvancado: filtroAvancado })
    }, 500)
  }

  componentDidUpdate(prevProps, prevState) {
    listPageUtils.componentDidUpdate(this, prevProps, prevState)
  }

  componentWillUnmount() {
    this.props.clearSelectedRecords()
  }

  onPage = (e) => {
    listPageUtils.onPage(this, e)
  }

  onSort = (e) => {
    listPageUtils.onSort(this, e)
  }

  exportar(excel = true) {
    listPageUtils.onCsvExport(this.props.records, this, actions, excel)
  }

  onSelectionChange = (e) => {
    this.props.setSelectedRecords(e.value)
  }

  showFilters = () => {
    this.showFilter = !this.showFilter
  }

  getDynamicFilters = (state) => {
    let result = []
    let valor = null
    let valorComplementar = null
    if (state.checkBoxEmissaoInicial) {
      valor = this.getFormulaForData(state.inicialValor, state.inicialModificador, state.inicialPeriodo)
    }

    if (state.checkBoxEmissaoFinal) {
      valorComplementar = this.getFormulaForData(state.finalValor, state.finalModificador, state.finalPeriodo)
    }

    if (valor) {
      const tipoFiltro = valorComplementar ? 'ENTRE' : 'MAIOR_IGUAL'
      result.push({
        campo: 'emissao',
        valor: valor,
        valorComplementar: valorComplementar,
        tipoFiltro: tipoFiltro,
      })
    }

    return result
  }

  getFormulaForData = (valor, modificador, periodo) => {
    let result = null
    if (valor === 1) {
      result = '$DATA_ATUAL'
    } else if (valor === 2) {
      result = '$INICIO_MES'
    } else if (valor === 3) {
      result = '$FINAL_MES'
    }

    if (typeof modificador !== 'string') {
      result = result + ';' + modificador
      if (periodo === 1) {
        result = result + ';d'
      } else if (periodo === 2) {
        result = result + ';s'
      } else if (periodo === 3) {
        result = result + ';m'
      }
    }
    return result
  }

  defineDynamicFilters = (state, onChangeData, onChangeCheckBox) => {
    return (
      <div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-12">
            <div class="p-grid p-justify-around">
              <span className="p-col-1 p-inputgroup-addon">
                <Checkbox
                  checked={state.checkBoxEmissaoInicial}
                  onChange={(e) => onChangeCheckBox(e)}
                  name="checkBoxEmissaoInicial"
                />
              </span>
              <span className="p-col-3 p-inputgroup-addon">
                <label>{utils.getMessage(this.messagesFilters, 'filtro.label.emissaoinicial')}</label>
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <Dropdown
                  value={state.inicialValor}
                  options={state.filtrosValorVisao}
                  onChange={(e) => onChangeData(e)}
                  name="inicialValor"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <InputNumber
                  value={state.inicialModificador}
                  onChange={(e) => onChangeData(e)}
                  min={-1000}
                  max={1000}
                  name="inicialModificador"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <Dropdown
                  value={state.inicialPeriodo}
                  options={state.filtrosPeriodoVisao}
                  onChange={(e) => {
                    onChangeData(e)
                  }}
                  disabled={!state.inicialModificador}
                  name="inicialPeriodo"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <label>{window.moment(state.inicialPreview).utc().format('DD/MM/YYYY')}</label>
              </span>
            </div>
          </div>
        </div>
        <br />
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-12">
            <div class="p-grid p-justify-around">
              <span className="p-col-1 p-inputgroup-addon">
                <Checkbox
                  checked={state.checkBoxEmissaoFinal}
                  onChange={(e) => onChangeCheckBox(e)}
                  name="checkBoxEmissaoFinal"
                />
              </span>
              <span className="p-col-3 p-inputgroup-addon">
                <label>{utils.getMessage(this.messagesFilters, 'filtro.label.emissaofinal')}</label>
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <Dropdown
                  value={state.finalValor}
                  options={state.filtrosValorVisao}
                  onChange={(e) => onChangeData(e)}
                  name="finalValor"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <InputNumber
                  value={state.finalModificador}
                  onChange={(e) => onChangeData(e)}
                  min={-1000}
                  max={1000}
                  name="finalModificador"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <Dropdown
                  value={state.finalPeriodo}
                  options={state.filtrosPeriodoVisao}
                  disabled={!state.finalModificador}
                  onChange={(e) => onChangeData(e)}
                  name="finalPeriodo"
                />
              </span>
              <span className="p-col-2 p-inputgroup-addon">
                <label>{window.moment(state.finalPreview).utc().format('DD/MM/YYYY')}</label>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }

  getCustomButtons = () => {
    return luGetCustomButtons(this)
  }

  // getCustomButtons = () => {
  //   return (
  //     <div>
  //       {this.state.permissoes && !this.state.permissoes.alterar ? null : (
  //         <Button
  //           disabled={!this.isLancamentosSelecionados()}
  //           onClick={(e) => this.props.showForm('baixarParcelas', true)}
  //           label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.baixar')}
  //           style={{ marginRight: '.25em' }}
  //           className="p-button-success"
  //         />
  //       )}
  //       <Button
  //         disabled={!this.isLancamentosSelecionados()}
  //         onClick={(e) => this.props.gerarDebitoAutomatico(this.props.selectedRecords)}
  //         label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.debitoAutomatico')}
  //         style={{ marginRight: '.25em' }}
  //         className="p-button-success"
  //       />
  //       <Button
  //         disabled={!this.isLancamentosSelecionados()}
  //         onClick={this.cancelarLancamentos}
  //         label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.cancelar')}
  //         style={{ marginRight: '.25em' }}
  //         className="p-button-danger"
  //       />
  //       <Button
  //         onClick={this.processarArquivoRetorno}
  //         label={'Processar Arquivo Retorno'}
  //         style={{ marginRight: '.25em' }}
  //         className="p-button-success"
  //       />
  //       <Button
  //         disabled={!this.isLancamentosSelecionados()}
  //         onClick={this.gerarNFSeLote}
  //         label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.gerarNfse')}
  //         style={{ marginRight: '.25em' }}
  //         className="p-button-success"
  //       />
  //     </div>
  //   )
  // }

  processarArquivoRetorno = () => {
    if (this.props.contasBancarias.length > 1) {
      this.setState({ contaBancaria: null })
    }
    if (this.props.contasCorrentes.length > 1) {
      this.setState({ contaCorrente: null })
    }
    this.setState({ showProcessarArquivoRetorno: true })
  }

  gerarNFSeLote = () => {
    this.setState({ showConfirmarGerarNFSeLote: true })
  }

  executarGerarNFSeLote = () => {
    this.props.gerarNFSeLote(this.props.selectedRecords)
  }

  cancelarLancamentos = () => {
    this.setState({ showConfirmarCancelar: true })
  }

  executarCancelamento = () => {
    this.props.cancelarLancamentos(this.props.selectedRecords)
  }

  onSelectArquivoRetorno = (e) => {
    if (
      ((this.state.contaBancaria && this.state.contaBancaria?.id) ||
        (this.state.contaCorrente && this.state.contaCorrente?.oid)) &&
      this.state.tipoImportacao === 'BOLETO'
    ) {
      this.hideDialog()
      this.props.addArquivoRetornoBoleto(e, this.state.contaBancaria?.id, this.state.contaCorrente?.oid)
    } else if (this.state.tipoImportacao === 'CELESC') {
      this.hideDialog()
      this.props.addArquivoRetornoCelesc(e)
    } else if (this.state.tipoImportacao === 'CERGRAL') {
      this.hideDialog()
      this.props.addArquivoRetornoCergral(e)
    } else if (this.state.tipoImportacao === 'DEBITO_AUTOMATICO') {
      this.hideDialog()
      this.props.addArquivoRetornoDebitoAutomatico(e)
    }
  }

  isLancamentosSelecionados = () => {
    const lancamentosSelecionados = this.props.selectedRecords
    return utils.isArrayNotEmpty(lancamentosSelecionados)
  }

  resolveLabelProcessarArquivos() {
    if (!this.state.tipoImportacao || this.state.contaBancaria || this.state.contaCorrente) {
      return 'Selecionar arquivo'
    }
    return 'Selecionar arquivo - primeiro selecione uma conta'
  }

  onChangeContas = (e) => {
    this.setState({ contaBancaria: e.target.value })
  }

  onChangeContaCorrente = (e) => {
    this.setState({ contaCorrente: e.target.value })
  }

  hideDialog = () => {
    this.setState({ showConfirmarCancelar: false })
    this.setState({ showProcessarArquivoRetorno: false })
    this.setState({ showConfirmarGerarNFSeLote: false })
  }

  onConfirmBaixarLancamentos = ({ valor, data, formaPagamento, lancamentos }) => {
    luOnConfirmBaixarLancamentos({ valor, data, formaPagamento, lancamentos, listPageContainer: this })
  }

  getModalBaixarLancamentos() {
    const lancamentosSelecionados = this.isLancamentosSelecionados()
    if (!lancamentosSelecionados) {
      return null
    }
    return (
      <BaixarLancamentoModal
        messages={this.props.messages}
        visible={this.props.displayForm.baixarParcelas}
        onHide={(e) => this.props.showForm('baixarParcelas', false)}
        lancamentosBaixar={this.props.selectedRecords}
        formasPagamento={this.props.formasPagamentoBasica}
        onConfirm={this.onConfirmBaixarLancamentos}
        labelBaixar={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.baixar')}
        labelValorPago={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.valorbaixa')}
        labelDataBaixa={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.databaixa')}
        labelConfirmar={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.confirmar')}
        bloquearLancamento={this.state.BLOQUEAR_LANCAMENTO} // verirficar isso
      />
    )
  }

  getDialogArquivoRetorno() {
    const footer = (
      <div>
        <Button
          label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.cancelar')}
          onClick={(e) => this.hideDialog()}
          className="p-button-danger"
          style={{ marginTop: '20px' }}
        />
      </div>
    )

    if (this.state.showProcessarArquivoRetorno) {
      return (
        <Dialog
          header={'Processar Arquivo Retorno'}
          visible={this.state.showProcessarArquivoRetorno}
          style={{ width: '30vw' }}
          onHide={(e) => this.hideDialog()}
          baseZIndex={1000000}
          modal={true}
          closable={true}
          footer={footer}
        >
          <div style={{ marginTop: '20px' }}>
            <RadioButton
              style={{ marginLeft: '5px' }}
              id="rbBanco"
              value={true}
              checked={this.state.tipoImportacao === 'BOLETO'}
              onChange={(e) => (this.state.tipoImportacao = 'BOLETO')}
            />
            <label className="p-radiobutton-label" htmlFor="rbBanco">
              Banco
            </label>
            <RadioButton
              style={{ marginLeft: '5px' }}
              id="rbCelesc"
              value={false}
              checked={this.state.tipoImportacao === 'CELESC'}
              onChange={(e) => (this.state.tipoImportacao = 'CELESC')}
            />
            <label className="p-radiobutton-label" htmlFor="rbCelesc">
              Celesc
            </label>
            <RadioButton
              style={{ marginLeft: '5px' }}
              id="rbCergral"
              value={false}
              checked={this.state.tipoImportacao === 'CERGRAL'}
              onChange={(e) => (this.state.tipoImportacao = 'CERGRAL')}
            />
            <label className="p-radiobutton-label" htmlFor="rbCergral">
              Cergral
            </label>
            <RadioButton
              style={{ marginLeft: '5px' }}
              id="rbDebitoAutomatico"
              value={false}
              checked={this.state.tipoImportacao === 'DEBITO_AUTOMATICO'}
              onChange={(e) => (this.state.tipoImportacao = 'DEBITO_AUTOMATICO')}
            />
            <label className="p-radiobutton-label" htmlFor="rbDebitoAutomatico">
              Débito automático
            </label>
            {this.getContaBancaria()}
            <div style={{ paddingTop: '20px' }}>
              <label className="label-btn-arquivo-retorno" htmlFor="selecao-arquivo">
                {this.resolveLabelProcessarArquivos()}
              </label>
              <input
                disabled={
                  !this.state.contaBancaria && !this.state.contaCorrente && this.state.tipoImportacao === 'BOLETO'
                }
                id="selecao-arquivo"
                type="file"
                onChange={(e) => this.onSelectArquivoRetorno(e)}
                style={{ marginTop: '.25em' }}
              />
            </div>
          </div>
        </Dialog>
      )
    }
    return null
  }

  getContaBancaria() {
    if (this.state.tipoImportacao === 'BOLETO') {
      if (this.props.contasCorrentes.length > 0) {
        return (
          <div style={{ paddingTop: '20px' }}>
            <span className="p-float-label">
              <Dropdown
                disabled={this.props.contasCorrentes.length === 1}
                autoWidth={false}
                value={this.state.contaCorrente}
                options={this.props.contasCorrentes}
                onChange={this.onChangeContaCorrente}
                optionLabel={(v) => v.numero + ' / ' + v.descricao}
                optionValue={(v) => v}
                dataKey="value"
                name="contas"
                style={{ width: '100%' }}
                inputId="conta_corrente"
              />
              <label htmlFor="conta_corrente">Conta Corrente</label>
            </span>
          </div>
        )
      } else {
        return (
          <div style={{ paddingTop: '20px' }}>
            <span className="p-float-label">
              <Dropdown
                disabled={this.props.contasBancarias.length === 1}
                autoWidth={false}
                value={this.state.contaBancaria}
                options={this.props.contasBancarias}
                onChange={this.onChangeContas}
                optionLabel="value"
                optionValue={(v) => v}
                dataKey="value"
                name="contas"
                style={{ width: '100%' }}
                inputId="conta_bancaria"
              />
              <label htmlFor="conta_bancaria">Conta</label>
            </span>
          </div>
        )
      }
    }
    return null
  }

  getDialogGerarNFSe() {
    if (this.state.showConfirmarGerarNFSeLote) {
      return (
        <ConfirmDialog
          visible={this.state.showConfirmarGerarNFSeLote}
          content={utils.getMessage(
            this.props.messagesDialog,
            'lancamentofinanceiro.dialog.message.confirmar.gerarNFSe'
          )}
          confirm={this.executarGerarNFSeLote}
          hideDialog={this.hideDialog}
        />
      )
    }
    return null
  }

  getDialogCancelar() {
    if (this.state.showConfirmarCancelar) {
      return (
        <ConfirmDialog
          visible={this.state.showConfirmarCancelar}
          content={utils.getMessage(
            this.props.messagesDialog,
            'lancamentofinanceiro.dialog.message.confirmar.cancelamento'
          )}
          confirm={this.executarCancelamento}
          hideDialog={this.hideDialog}
        />
      )
    }
    return null
  }

  realizarBaixaLancamentosFilhos = () => {
    if (this.props.selectedRecords && this.props.selectedRecords.length > 0 && this.props.record.dataPagamentoParcela) {
      this.props.selectedRecords.forEach((lancamento) => {
        lancamento.dataPagamento = this.props.record.dataPagamentoParcela
        lancamento.valor = utils.parseStringToNumber(lancamento.valor)
        lancamento.valorPago = lancamento.valor
      })
      this.props.baixarLancamentos(this.props.selectedRecords)
    }
  }

  buildAdvancedFilters = () => {
    if (this.showFilter) {
      return (
        <div className="p-col-12 p-justify-start">
          <div className="p-grid form-group p-align-center">
            {/* UNIDADES */}
            <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <MultiSelect
                  className={'min-width-15-rem'}
                  value={_.get(this.props.filterValues, ['unidade', 'valor'])}
                  options={utils.convertArrayIdValueToIdLabel(this.props.opcoesUnidades)}
                  name="unidades"
                  optionLabel="label"
                  dataKey="id"
                  onChange={this.onChangeUnit}
                  disabled={this.props.disableUnit}
                  selectedItemsLabel="{0} itens selecionados"
                />
                <label>{utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.unidades')}</label>
              </span>
            </div>
          </div>
          <div className="p-grid form-group p-align-center">
            <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <Dropdown
                  className={'width-15-rem'}
                  value={_.get(this.props.filterValues, ['emissao', 'tipoFiltro'])}
                  options={this.props.tiposFiltros}
                  onChange={(e) => _.set(this.props.filterValues, 'emissao.tipoFiltro', e.value)}
                  optionLabel="label"
                  optionValue={(v) => v}
                  name="tipo"
                />
                <label>{utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.emissao')}</label>
              </span>
            </div>

            {isTipoFiltroSelecionado(_.get(this.props.filterValues, ['emissao', 'tipoFiltro'], false)) ? (
              <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                <span className="md-inputfield">
                  <Calendar
                    value={_.get(this.props.filterValues, ['emissao', 'valor'], null)}
                    name="dataInicial"
                    monthNavigator={true}
                    onChange={(e) => this.changeDataFiltro('emissao.valor', e.value)}
                  />
                </span>
              </div>
            ) : (
              ''
            )}
            {
              // SE FILTRO TEM DATA FINAL PARA FILTRAR MOSTRAR O CAMPO
              isTipoFiltroSelecionadoComplementar(_.get(this.props.filterValues, ['emissao', 'tipoFiltro'])) ? (
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                  <span className="md-inputfield">
                    <Calendar
                      value={_.get(this.props.filterValues, ['emissao', 'valorComplementar'], null)}
                      name="dataFinal"
                      monthNavigator={true}
                      onChange={(e) => this.changeDataFiltro('emissao.valorComplementar', e.value)}
                    />
                  </span>
                </div>
              ) : (
                ''
              )
            }
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <Dropdown
                  className={'width-15-rem'}
                  value={_.get(this.props.filterValues, ['vencimento', 'tipoFiltro'])}
                  options={this.props.tiposFiltros}
                  onChange={(e) => _.set(this.props.filterValues, 'vencimento.tipoFiltro', e.value)}
                  optionLabel="label"
                  optionValue={(v) => v}
                  name="tipo"
                />
                <label>{utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.vencimento')}</label>
              </span>
            </div>
            {
              // SE FILTRO TEM DATA INICIAL PARA FILTRAR MOSTRAR O CAMPO
              isTipoFiltroSelecionado(_.get(this.props.filterValues, ['vencimento', 'tipoFiltro'], false)) ? (
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                  <span className="md-inputfield">
                    <Calendar
                      value={_.get(this.props.filterValues, ['vencimento', 'valor'], null)}
                      name="vencimento"
                      monthNavigator={true}
                      onChange={(e) => this.changeDataFiltro('vencimento.valor', e.value)}
                    />
                  </span>
                </div>
              ) : (
                ''
              )
            }
            {
              // SE FILTRO TEM DATA FINAL PARA FILTRAR MOSTRAR O CAMPO
              isTipoFiltroSelecionadoComplementar(_.get(this.props.filterValues, ['vencimento', 'tipoFiltro'])) ? (
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                  <span className="md-inputfield">
                    <Calendar
                      value={_.get(this.props.filterValues, ['vencimento', 'valorComplementar'], null)}
                      name="vencimento"
                      monthNavigator={true}
                      onChange={(e) => this.changeDataFiltro('vencimento.valorComplementar', e.value)}
                    />
                  </span>
                </div>
              ) : (
                ''
              )
            }
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <Dropdown
                  className={'width-15-rem'}
                  value={_.get(this.props.filterValues, ['dataPagamento', 'tipoFiltro'])}
                  options={this.props.tiposFiltros}
                  onChange={(e) => _.set(this.props.filterValues, 'dataPagamento.tipoFiltro', e.value)}
                  optionLabel="label"
                  optionValue={(v) => v}
                  name="tipo"
                />
                <label>{utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.pagamento')}</label>
              </span>
            </div>
            {
              // SE FILTRO TEM DATA INICIAL PARA FILTRAR MOSTRAR O CAMPO
              isTipoFiltroSelecionado(_.get(this.props.filterValues, ['dataPagamento', 'tipoFiltro'], false)) ? (
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                  <span className="md-inputfield">
                    <Calendar
                      value={_.get(this.props.filterValues, ['dataPagamento', 'valor'])}
                      name="pagamento"
                      monthNavigator={true}
                      onChange={(e) => this.changeDataFiltro('dataPagamento.valor', e.value)}
                    />
                  </span>
                </div>
              ) : (
                ''
              )
            }
            {
              // SE FILTRO TEM DATA FINAL PARA FILTRAR MOSTRAR O CAMPO
              isTipoFiltroSelecionadoComplementar(_.get(this.props.filterValues, ['dataPagamento', 'tipoFiltro'])) ? (
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
                  <span className="md-inputfield">
                    <Calendar
                      value={_.get(this.props.filterValues, ['dataPagamento', 'valorComplementar'])}
                      name="pagamento"
                      monthNavigator={true}
                      onChange={(e) => this.changeDataFiltro('dataPagamento.valorComplementar', e.value)}
                    />
                  </span>
                </div>
              ) : (
                ''
              )
            }
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <LtsLookupMarcador
                  label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.marcador')}
                  value={_.get(this.state.filtroAvancado, ['marcador', 'valor', 'descricao'])}
                  history={this.props.history}
                  editHidden={true}
                  field={'codigo'}
                  multiple={false}
                  onChange={(e) => {
                    let data = { oid: _.get(e, 'oid', ''), descricao: _.get(e, 'codigo', '') }
                    _.set(this.props.filterValues, 'marcador.valor', data)
                    _.set(this.state.filtroAvancado, 'marcador.valor', data)
                    this.setState({ filtroAvancado: this.state.filtroAvancado })
                  }}
                  showAddButton={false}
                  tipo={'LANCAMENTO'}
                />
              </span>
            </div>
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-12 p-sm-12 p-md-4 p-lg-4 p-xl-4">
              <span className="p-float-label">
                <LtsLookupContaCorrente
                  label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.contacorrente')}
                  value={_.get(this.state.filtroAvancado, ['contaCorrente', 'valor', 'descricao'])}
                  history={this.props.history}
                  onChange={(e) => {
                    let data = { oid: _.get(e, 'oid', ''), descricao: _.get(e, 'descricao', '') }
                    _.set(this.props.filterValues, 'contaCorrente.valor', data)
                    _.set(this.state.filtroAvancado, 'contaCorrente.valor', data)
                    this.setState({ filtroAvancado: this.state.filtroAvancado })
                  }}
                  editHidden={true}
                />
              </span>
            </div>
          </div>

          <div className="p-grid form-group p-align-baseline">
            <div className="p-col-12 p-sm-12 p-md-7 p-lg-6 p-xl-4">
              <LtsLookupItemLancamento
                header={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.produtosServicos')}
                label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.produtosServicos')}
                value={_.get(this.state.filterValues, 'taxa.valor.descricao', '')}
                history={this.props.history}
                onChange={(e) => this.lookupTaxaOnChange(e)}
                idUnidade={_.get(this.props, 'record.unidade.id', null)}
                tipoItem={_.get(this.props, 'tipoItem', null)}
                editHidden={true}
              />
            </div>
          </div>

          <div className="p-grid form-group p-align-baseline">
            <div className="p-col-12 p-sm-12 p-md-7 p-lg-6 p-xl-4">
              <LtsLookupNotaFiscalServico
                header={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.notaFiscalServico')}
                label={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.notaFiscalServico')}
                value={_.get(this.state.filterValues, 'nfse.valor.numeroNFSe', '')}
                history={this.props.history}
                onChange={(e) => this.lookupNotaFiscalServicoOnChange(e)}
                idUnidade={_.get(this.props, 'record.unidade.id', null)}
                editHidden={true}
              />
            </div>
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-2 p-sm-2 p-md-2 p-lg-2 p-xl-2">
              <label className="label">
                {utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.semNota')}
              </label>
              <Checkbox
                style={{ marginLeft: '1rem' }}
                checked={_.get(this.props.filterValues, ['semNota', 'valor'])}
                onChange={(e) =>
                  _.set(this.props.filterValues, 'semNota.valor', !_.get(this.props.filterValues, ['semNota', 'valor']))
                }
              />
            </div>
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-2 p-sm-2 p-md-2 p-lg-2 p-xl-2">
              <label className="label">
                {utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.boleto')}
              </label>
              <Checkbox
                style={{ marginLeft: '1rem' }}
                checked={_.get(this.props.filterValues, ['boleto', 'valor'])}
                onChange={(e) =>
                  _.set(this.props.filterValues, 'boleto.valor', !_.get(this.props.filterValues, ['boleto', 'valor']))
                }
              />
            </div>
          </div>

          <div className="p-grid form-group p-align-center">
            <div className="p-col-2 p-sm-2 p-md-2 p-lg-2 p-xl-2">
              <label className="label">
                {utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.vencido')}
              </label>
              <Checkbox
                style={{ marginLeft: '0.25rem' }}
                checked={_.get(this.props.filterValues, ['vencido', 'valor'])}
                onChange={(e) =>
                  _.set(this.props.filterValues, 'vencido.valor', !_.get(this.props.filterValues, ['vencido', 'valor']))
                }
              />
            </div>
          </div>
          <br />
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-3 p-lg-2 p-xl-2">
              <Button
                icon={icons.SEARCH_ICON}
                style={{ marginRight: '.25em' }}
                label={utils.getMessage(this.props.messages, 'label.pesquisar')}
                onClick={this.pesquisaAvancada}
              />
            </div>
          </div>
        </div>
      )
    }
  }

  buildHeader = () => {
    return (
      <DefaultToolBar
        listPageContainer={this}
        title={utils.getMessage(this.props.messages, 'lancamentofinanceiro.label.lancamentos')}
      />
    )
  }

  getBooleanFilterOptions = (column) => {
    if (column.field === 'grupoItemPrincipal_tipo') {
      return this.props.booleanTypes
    } else if (column.field === 'tipoFormaPagamento') {
      return this.props.booleanTypesFormaPagamento
    }
    return this.props.booleanTypesStatus
  }

  statusTemplate = (rowData, column) => {
    if (column.field === 'status') {
      let color = 'grey'
      let title = 'Em aberto'
      const result = rowData[column.field]
      if (result === 'PAGO') {
        color = 'green'
        title = 'Pago'
      } else if (result === 'CANCELADO') {
        color = 'red'
        title = 'Cancelado'
      }
      return (
        <div style={{ color: `${color}`, display: 'flex', justifyContent: 'center' }}>
          <span className="pi pi-circle-fill" style={{ fontSize: '1.5rem' }} title={title} />
        </div>
      )
    }
  }

  tipoPagamentoFilter = (column) => {
    return (
      <MultiSelect
        style={{ width: '100%', minWidth: '10px' }}
        name={column.field}
        value={this.props.booleanFilter[column.field]}
        options={this.getBooleanFilterOptions(column)}
        onChange={(e) => {
          _.set(this.props.filterValues, [column.field, 'valor'], e.value)
          this.props.changeFilter(column, e)
        }}
      />
    )
  }

  booleanFilter = (column) => {
    return (
      <Dropdown
        style={{ width: '100%', minWidth: '10px' }}
        name={column.field}
        value={_.get(this.props.filterValues, [column.field, 'valor'])}
        options={this.getBooleanFilterOptions(column)}
        onChange={(e) => {
          _.set(this.props.filterValues, [column.field, 'valor'], e.value)
          this.props.changeFilter(column, e)
        }}
      />
    )
  }

  booleanFieldsTemplate = (rowData, column) => {
    if (rowData[column.field]) {
      if (column.field === 'grupoItemPrincipal_tipo') {
        return <div>{[rowData[column.field]]}</div>
      } else if (column.field === 'tipoFormaPagamento') {
        return (
          <div title={enums.CONVERTER_FORMA_PAGAMENTO[rowData[column.field]]}>
            {enums.CONVERTER_FORMA_PAGAMENTO[rowData[column.field]]}
          </div>
        )
      }
    }
    return null
  }

  oidTemplate = (rowData) => {
    return <Link to={`${routes.PATH_LANCAMENTO_FINANCEIRO_VENDAS}/${rowData.oid}`}>{rowData.oid}</Link>
  }

  formatColumn = (rowData, column) => {
    if (column.field === 'oidContrato' && rowData.oidContrato) {
      const defaultValue = _.defaultTo(rowData.contrato_numero, rowData.oidContrato)
      return <Link to={`${routes.PATH_CONTRATO}/${rowData.oidContrato}`}>{defaultValue}</Link>
    }
    if (column.field === 'boleto_oid' && utils.nonNull(rowData[column.field])) {
      return <Button type="button" onClick={(e) => this.props.gerarBoletoLancamento(rowData)} icon={icons.DOWNLOAD} />
    }
    return utils.format(rowData, column)
  }

  fieldCalendarFilter = (column) => {
    return (
      <Calendar
        value={_.get(this.props.filterValues, [column.field, 'valor'])}
        yearNavigator={true}
        monthNavigator={true}
        yearRange={utils.getYearRangeFromDate('1900')}
        appendTo={document.body}
        showButtonBar={true}
        onChange={(e) => this.props.changeFilter(column, e)}
        name={column.field}
      />
    )
  }
  fieldFilter = (column) => {
    return (
      <InputText
        style={{ width: '100%' }}
        name={column.field}
        value={_.get(this.props.filterValues, [column.field, 'valor'])}
        onChange={(e) => this.props.changeFilter(column, e)}
      />
    )
  }
  defineColumns = () => {
    const visibleColumns = this.props.columns.filter((col) => col.visible)
    return visibleColumns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false
      if (col.field === 'multiselect') {
        return <Column selectionMode="multiple" style={{ width: '3em' }} />
      }
      if (col.field === 'oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.oidTemplate}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-oid-body-width"
            filterHeaderClassName="column-oid-filter-header-width"
            headerClassName="column-oid-header-width"
          />
        )
      }
      if (
        col.field === 'emissao' ||
        col.field === 'vencimento' ||
        col.field === 'dataPagamento' ||
        col.field === 'dataImportacao'
      ) {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldCalendarFilter(col)}
            bodyClassName="column-date-body-width"
            filterHeaderClassName="column-date-filter-header-width"
            headerClassName="column-date-header-width"
          />
        )
      }
      if (col.field === 'grupoItemPrincipal_tipo') {
        return (
          <Column
            {...col}
            key={col.field}
            filterHeaderStyle={{ overflow: 'visible' }}
            sortField={col.columnSortField}
            body={this.booleanFieldsTemplate}
            filterElement={this.booleanFilter(col)}
            bodyClassName="column-grupo-tipo-body-width"
            filterHeaderClassName="column-grupo-tipo-filter-header-width"
            headerClassName="column-grupo-tipo-header-width"
          />
        )
      }
      if (col.field === 'grupoItemPrincipal_descricao' || col.field === 'contaCorrente_descricao') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            style={{ textAlign: 'left' }}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-grupo-body-width"
            filterHeaderClassName="column-grupo-filter-header-width"
            headerClassName="column-grupo-header-width"
            body={listPageUtils.bodyDivWithTooltip}
          />
        )
      }
      if (col.field === 'status') {
        return (
          <Column
            {...col}
            key={col.field}
            filterHeaderStyle={{ overflow: 'visible' }}
            sortField={col.columnSortField}
            body={this.statusTemplate}
            filterElement={this.booleanFilter(col)}
            bodyClassName="column-status-body-width"
            filterHeaderClassName="column-status-filter-header-width"
            headerClassName="column-status-header-width"
          />
        )
      }
      if (col.field === 'tipoFormaPagamento') {
        return (
          <Column
            {...col}
            key={col.field}
            filterHeaderStyle={{ overflow: 'visible' }}
            sortField={col.columnSortField}
            body={this.booleanFieldsTemplate}
            filterElement={this.tipoPagamentoFilter(col)}
            bodyClassName="column-forma-pagamento-body-width"
            filterHeaderClassName="column-forma-pagamento-filter-header-width"
            headerClassName="column-forma-pagamento-header-width"
          />
        )
      }
      if (col.field === 'valor' || col.field === 'valorPago') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-valor-body-width"
            filterHeaderClassName="column-valor-filter-header-width"
            headerClassName="column-valor-header-width"
          />
        )
      }
      if (col.fieldFormatter || col.field === 'oidContrato') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-oid-body-width"
            filterHeaderClassName="column-oid-filter-header-width"
            headerClassName="column-oid-header-width"
          />
        )
      }
      if (col.field === 'boleto_oid') {
        return (
          <Column
            {...col}
            key={col.field}
            body={this.formatColumn}
            sortField={col.columnSortField}
            style={{ textAlign: 'center' }}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-oid-body-width"
            filterHeaderClassName="column-oid-filter-header-width"
            headerClassName="column-oid-header-width"
          />
        )
      }
      if (col.field === 'observacao') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            style={{ textAlign: 'left' }}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-observacao-body-width"
            filterHeaderClassName="column-observacao-filter-header-width"
            headerClassName="column-observacao-header-width"
            body={listPageUtils.bodyDivWithTooltip}
          />
        )
      }
      if (col.field === 'localizacao_identificacao') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-localizacao-body-width"
            filterHeaderClassName="column-localizacao-filter-header-width"
            headerClassName="column-localizacao-header-width"
          />
        )
      }
      if (col.field === 'bandeira_cartao') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-localizacao-body-width"
            filterHeaderClassName="column-localizacao-filter-header-width"
            headerClassName="column-localizacao-header-width"
          />
        )
      }
      if (col.field === 'unidade_sigla') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-unidade-body-width"
            filterHeaderClassName="column-unidade-filter-header-width"
            headerClassName="column-unidade-header-width"
          />
        )
      }
      if (col.field === 'pagador_nome' || col.field === 'vendedor_nome') {
        return (
          <Column
            {...col}
            key={col.field}
            sortField={col.columnSortField}
            filterElement={this.fieldFilter(col)}
            bodyClassName="column-nome-body-width"
            filterHeaderClassName="column-nome-filter-header-width"
            headerClassName="column-nome-header-width"
            body={listPageUtils.bodyDivWithTooltip}
          />
        )
      }
      if (col.field !== 'contrato_numero') {
        return <Column {...col} key={col.field} sortField={col.columnSortField} filterElement={this.fieldFilter(col)} />
      }
    })
  }

  hideDialogRemoverVisao = () => {
    this.setState({ showDialogRemoveVisao: false })
  }

  buildContent = () => {
    return (
      <div>
        {this.getModalBaixarLancamentos()}
        {this.getDialogCancelar()}
        {this.getDialogArquivoRetorno()}
        {this.getDialogGerarNFSe()}
        {luGetDialogConfirmarFecharPedidos(this)}
        {luGetDialogConfirmarReajustarLancamento(this)}
        <LancamentoVendasList
          {...this.props}
          onSelectionChange={this.onSelectionChange}
          dataTableRef={(el) => (this.dataTableRef = el)}
          onColReorder={(e) => this.onColReorder(e, this.showHideColumns)}
          onPage={this.onPage}
          onSort={this.onSort}
          columns={this.defineColumns()}
        />
      </div>
    )
  }

  render() {
    if (this.props.columns && this.props.columns.length > 0) {
      return <Page header={this.buildHeader()} content={this.buildContent()} />
    }
    return <LoadingSpinner />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LancamentoVendasListPageContainer)
